import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAlertStore = defineStore('alert', () => {
	// data
	const items = ref<
		{
			id: number;
			title: string;
			message?: string;
			success?: boolean;
			error?: boolean;
			warn?: boolean;
			info?: boolean;
		}[]
	>([]);
	const timeout = ref<number>(5000);

	// methods
	function error(title: string, message?: string): void {
		const id = items.value.length + 1;
		items.value.push({
			id,
			title,
			message,
			error: true,
		});
		remove(id);
	}
	function success(title: string, message?: string): void {
		const id = items.value.length + 1;
		items.value.push({
			id,
			title,
			message,
			success: true,
		});
		remove(id);
	}
	function warn(title: string, message?: string): void {
		const id = items.value.length + 1;
		items.value.push({
			id,
			title,
			message,
			warn: true,
		});
		remove(id);
	}
	function info(title: string, message?: string): void {
		const id = items.value.length + 1;
		items.value.push({
			id,
			title,
			message,
			info: true,
		});
		remove(id);
	}
	function remove(id: number) {
		setTimeout(() => {
			const index = items.value.findIndex((el) => el.id === id);
			items.value.splice(index, 1);
		}, timeout.value);
	}

	return {
		items,

		error,
		success,
		warn,
		info,
	};
});
